import React from 'react';
import { useSelector } from 'react-redux';
import styled, { css } from 'styled-components';

const TimeWrap = styled.div`
  font-size: 30px;
  font-weight: 600;
  color: #5493fc;

  ${(props) => props.page && css`
    font-size: 40px;
  `}
`;

const Time = styled.span`
  font-size: 30px;
  font-weight: 600;
  color: #5493fc;

  ${(props) => props.page && css`
    font-size: 40px;
  `}
`;

export const AudioPlayerTime = (props) => {
  const state = useSelector((state) => state);

  return (
    <TimeWrap page={props.page}>
      <Time page={props.page}>{state.track.current_time}</Time>
      &nbsp;/&nbsp;
      <Time page={props.page}>{state.track.duration_time}</Time>
    </TimeWrap>
  );
};